import { useSelector } from 'react-redux';

const useFormattedRoomName = (roomCategoryName, roomTypeName, productCode) => {
  const hotels = useSelector((state) => state.belmond.hotels);
  const activeSpecialCode = useSelector(
    (state) => state.bookings.activeSpecialCode
  );

  if (!roomCategoryName) {
    return '';
  }

  if (
    hotels[productCode]?.displayRoomsWithoutCategories ||
    ['COMP', 'DISC'].includes(activeSpecialCode)
  ) {
    return roomTypeName;
  }

  const formattedRoomCategoryName = roomCategoryName.toLowerCase().endsWith('s')
    ? roomCategoryName.slice(0, -1)
    : roomCategoryName;

  const formattedRoomTypeName = roomTypeName ? ` - ${roomTypeName}` : '';

  return `${formattedRoomCategoryName}${formattedRoomTypeName}`;
};

export default useFormattedRoomName;
